import React, { FC } from 'react';

import { VideoContainer, VideoPlayer } from './styles';

type Props = {
    videoId: string | null;
    closeVideoModal: () => void;
};

const VIDEO_PLAYER_URL = 'https://players.brightcove.net/6415718365001/default_default/index.html?videoId=';

const VideoModal: FC<Props> = ({ videoId, closeVideoModal }) => {
    if (!videoId) {
        return null;
    }
    return (
        <VideoContainer className="videoModal" onClick={closeVideoModal}>
            <VideoPlayer>
                <iframe
                    src={`${VIDEO_PLAYER_URL}${videoId}`}
                    allowFullScreen
                    height="100%"
                    width="100%"
                    allow="autoplay; encrypted-media"
                />
            </VideoPlayer>
        </VideoContainer>
    );
};

export default VideoModal;
